import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles<Theme>(() => {
  return {
    video: {
      display: 'none',
    },
  };
});
